// @flow
import React from 'react';
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';
import SizeGridItem from './SizeGridItem';

type Props = {
  isSingleDimension: boolean,
  grid: {
    cols: Array<string>,
    rows: Array<string>,
    items: Array<Sku>,
  },
  setRefOnParent: ?() => void,
  onChange: () => void,
  selectedSku: Sku,
  sizeType: string,
};

const messages = defineMessages({
  'gridRow-dress': { id: 'size-grid.dress-row', defaultMessage: '{value}' },
  'gridRow-size': { id: 'size-grid.size-row', defaultMessage: '{value}' },
  'gridRow-back': { id: 'size-grid.back-row', defaultMessage: '{value}' },
  gridCol: { id: 'size-grid.col', defaultMessage: '{value}' },
});

const SizeGridTable = (props: Props) => {
  const {
    grid,
    setRefOnParent,
    onChange,
    isSingleDimension,
    sizeType = 'size',
  } = props;

  return (
    <table
      ref={table => {
        setRefOnParent(table);
      }}
      className="c-size-grid"
    >
      <thead>
        <tr>
          {!isSingleDimension && <th />}
          {grid.cols.map((col, index) => {
            const headProps = {};
            if (isSingleDimension && index === 0) {
              headProps.className = 'single-dimension';
            }
            return (
              <th {...headProps} key={`col-${col}`}>
                <FormattedMessage
                  {...messages.gridCol}
                  values={{ value: col }}
                />
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {grid.rows.map((row, rowIndex) => (
          <tr key={`row-${row}`}>
            {!isSingleDimension && (
              <th>
                <FormattedMessage
                  {...messages[`gridRow-${sizeType}`]}
                  values={{ value: row }}
                />
              </th>
            )}
            {grid.cols.map(col => {
              let item;
              if (!isSingleDimension) {
                item = grid.items[rowIndex].sizes.variants.find(
                  gridItem => gridItem.value === col
                );
              }
              if (isSingleDimension) {
                item = grid.items.find(i => {
                  // Remove any non alphanumeric characters
                  return i.value === col.replace(/[^0-9a-z]/gi, '');
                });
              }
              return item ? (
                <SizeGridItem
                  sku={item}
                  key={`grid-item-${item.skuCode}`}
                  onChange={onChange}
                  selected={
                    !!props.selectedSku &&
                    props.selectedSku.skuCode === item.skuCode
                  }
                />
              ) : (
                <td key={`grid-item-empty-${row}-${col}`} />
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

SizeGridTable.defaultProps = {
  setRefOnParent: () => {},
};

export default injectIntl(SizeGridTable);
